import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import NoDataMsg from 'library/noData';
// Child Components
import SalesChart from './SalesChart';
import AverageNetChart from './AverageNetChart';
import NumberTransChart from './NumberTransChart';

const Body = () => {
    const { hourlySales } = useSelector(state => state.reports || {});
    const { HourlySalesSelectedDate } = useSelector(state => state.form || {});
    const selectedDate = moment(HourlySalesSelectedDate).format("YYYY-MM-DD");
    
    return(
        <React.Fragment>
            {hourlySales && hourlySales.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div className="clearfix">
                    <div className="text-center list_header">
                        {selectedDate ?
                            <p><i>Selected Date</i> <b>{moment(selectedDate).format('MMMM Do, YYYY')}</b></p>
                            : ""}
                    </div>
                    <div className="col-lg-12 mt-2 bg-light clearfix" >
                        <SalesChart />
                        <AverageNetChart />
                        <NumberTransChart />
                    </div>
                </div>
            }
        </React.Fragment>
    )
};
export default Body;